<template>
  <div id="user">
      <body style="background-color: #FAFAFA">
        <header >
            <UserNavigation />
        </header>        
       
        <main>
          <UserMain/>
        </main>
           
        <footer style="background-color: #292929; position:fixed; bottom:0; width: 100%;">
            <WebsiteFooter/>
        </footer>
      </body>
  </div>
</template>

<script>
import UserNavigation from '../components/UserNavigation'
import UserMain from '../components/UserMain'
import WebsiteFooter from '../components/WebsiteFooter'

import firebase from "firebase";

export default {
  name: "user",

  data() {
    return {
    }
  },

  components:{
    UserNavigation,
    UserMain,
    WebsiteFooter
  },

  computed: {
		isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  },
  
  watch:{
    isIdle() {
      if(this.$store.state.idleVue.isIdle == true){
        firebase.auth().signOut().then(() => {
          this.$router.replace("/");
          window.location.reload();
        },
        error => {
          console.log(error);
        });
      }
    }
  }
};
</script>